import { render, staticRenderFns } from "./Seller.vue?vue&type=template&id=68934408&"
import script from "./Seller.vue?vue&type=script&lang=js&"
export * from "./Seller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports